import React from 'react';
import { FiMousePointer } from 'react-icons/fi';

import { Kbd } from '@core/ui/primitives/kbd';

function Item({ keys, label }: { keys: React.ReactNode; label: string }) {
  return (
    <div className='flex items-center gap-2'>
      <div className='flex flex-wrap items-center gap-1' aria-hidden>
        {keys}
      </div>
      <span className='text-xs text-muted-foreground'>{label}</span>
    </div>
  );
}

export function KeyboardShortcutsLegend() {
  return (
    <footer data-testid='mindmap-legend' role='contentinfo' className='w-full border-t bg-background/70 px-3 py-2'>
      <div className='mx-auto grid max-w-5xl grid-cols-1 gap-2 text-xs sm:grid-cols-5 sm:divide-x sm:divide-border'>
        {/* 1: Navigation */}
        <div data-testid='mindmap-legend-col' className='space-y-1 sm:pr-3'>
          <Item keys={<Kbd keys={['up', 'down']} size='sm' />} label='navigate between siblings' />
          <Item keys={<Kbd keys={['left', 'right']} size='sm' />} label='navigate between levels' />
        </div>

        {/* 2: Mode/Scroll/Drag */}
        <div data-testid='mindmap-legend-col' className='space-y-1 sm:px-3'>
          <div className='flex items-center gap-2 text-muted-foreground'>
            <FiMousePointer aria-hidden size={12} />
            <span>double-click to swap mode (pan/select)</span>
          </div>
          <div className='flex items-center gap-2 text-muted-foreground'>
            <FiMousePointer aria-hidden size={12} />
            <span>scroll: zoom/pan by mode</span>
          </div>
          <div className='flex items-center gap-2 text-muted-foreground'>
            <FiMousePointer aria-hidden size={12} />
            <span>drag: pan/select by mode</span>
          </div>
        </div>

        {/* 3: Create sibling/child */}
        <div data-testid='mindmap-legend-col' className='space-y-1 sm:px-3'>
          <Item keys={<Kbd keys={['enter']} size='sm' />} label='create sibling' />
          <Item keys={<Kbd keys={['tab']} size='sm' />} label='create child last' />
        </div>

        {/* 4: Create before/first */}
        <div data-testid='mindmap-legend-col' className='space-y-1 sm:px-3'>
          <Item keys={<Kbd keys={['Shift', 'Enter']} size='sm' />} label='create sibling before' />
          <Item keys={<Kbd keys={['Shift', 'Tab']} size='sm' />} label='create child first' />
        </div>

        {/* 5: Rename/Delete */}
        <div data-testid='mindmap-legend-col' className='space-y-1 sm:pl-3'>
          <Item keys={<Kbd keys={['F2']} size='sm' />} label='rename a node (edit mode)' />
          <Item keys={<Kbd keys={['backspace', 'Del']} size='sm' />} label='delete a node and its subtree' />
        </div>
      </div>
    </footer>
  );
}
